import { render, staticRenderFns } from "./PontoExterno.vue?vue&type=template&id=6df04c0a&"
import script from "./PontoExterno.vue?vue&type=script&lang=js&"
export * from "./PontoExterno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports